export type MetodoPagoCFDType = "PUE" | "PPD";

const MetodoPagoCFDIEnum = {
  "PUE": "Pago en una sola exhibición (de contado).",
  "PPD": "Pago en parcialidades o diferido (total o parcialmente a crédito). Requiere expedir un comprobante de pago cuando se reciba un pago subsecuente.",
};
Object.freeze(MetodoPagoCFDIEnum);

export default MetodoPagoCFDIEnum;